import api from './api'
import { ChecklistReserva, DashboardResumoAdmin } from '@/types/resumoAdmin'

/**
 * Client da visão administrativa (Onda 2 / A05).
 *
 * Existe separado do `dashboardService` de propósito: aquele é consumido pelo
 * Dashboard do consultor (A04, em paralelo nesta rodada) e o contrato comum
 * proíbe duas mãos no mesmo service. O endpoint é o MESMO
 * `/v1/dashboard/resumo` — só o tipo da resposta é o estendido do A03.
 */
export const resumoAdminService = {
  /**
   * `canal` (decisão 6.7): recorta os agregados por canal comercial — o backend
   * ignora o parâmetro para consultor. `'SEM_CANAL'` = reservas anteriores ao
   * carimbo. O backend devolve o objeto puro (sem envelope ApiResponse).
   */
  getResumo: async (canal?: string): Promise<DashboardResumoAdmin> => {
    const query = canal ? `?canal=${encodeURIComponent(canal)}` : ''
    return await api.get<DashboardResumoAdmin>(`/api/v1/dashboard/resumo${query}`)
  },

  /**
   * Cabeçalho do checklist da reserva (Onda 4 / A08) — fonte da coluna
   * "Documentação %" da Estruturação Administrativa. Por reserva: a listagem em
   * lote ainda não traz o percentual (lacuna relatada ao coordenador).
   */
  checklistReserva: async (id: string): Promise<ChecklistReserva> => {
    return await api.get<ChecklistReserva>(`/api/v1/oportunidades/${id}/checklist`)
  },
}
